import {
  Component,
  forwardRef,
  Input,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { GridComponent } from "@app/modules/shared/components/grid/grid.component";
import { FilterCardWithCode } from "@dashboard/constants/filters";

@Component({
  selector: "kl-special-code-list",
  templateUrl: "./specode-list.component.html",
  styleUrls: ["./specode-list.component.scss"],
})
export class SpeCodeListComponent implements OnInit {
  templateContext: any;
  @Input() mode: string;
  @Input() tabId: string;
  @Input() modalId: string;
  @Input() dblSelect = false;
  @ViewChild(forwardRef(() => GridComponent), { static: true })
  private gridComponent: GridComponent;
  filterSelectItems = FilterCardWithCode;
  constructor() {}

  ngOnInit() {
    if (this.templateContext) {
      this.gridComponent.templateContext = this.templateContext;
    }
    if (this.mode) {
      this.gridComponent.mode = this.mode;
    }
  }
}
